// 新闻管理
const userManage = () => import('@/view/user-manage/user-manage'); //用户列表
const userDetail = () => import('@/view/user-manage/user-detail'); //用户详情
const consultationFrequency = () => import('@/view/user-manage/consultation-frequency'); //咨询次数
const userPortrait = () => import('@/view/user-manage/user-portrait'); //咨询次数
const consultKeyword = () => import('@/view/user-manage/consult-keyword'); //咨询次数
const aiAnswer = () => import('@/view/user-manage/ai-answer'); //咨询次数
const dietitian = () => import('@/view/user-manage/dietitian'); //咨询次数
const portraitData = () => import('@/view/user-manage/portrait-data'); //咨询次数
const portraitDataSearch = () => import('@/view/user-manage/portrait-data-search'); //咨询次数
const platformDataQuery = () => import('@/view/user-manage/platform-data-query'); //咨询次数

export default [{
        path: '/user-manage',
        name: 'userManage',
        component: userManage
    },
    {
        path: '/user-detail',
        name: 'userDetail',
        component: userDetail
    },
    {
        path: '/consultation-frequency',
        name: 'consultationFrequency',
        component: consultationFrequency
    }, {
        path: '/user-portrait',
        name: 'userPortrait',
        component: userPortrait
    }, {
        path: '/consult-keyword',
        name: 'consultKeyword',
        component: consultKeyword
    }, {
        path: '/ai-answer',
        name: 'aiAnswer',
        component: aiAnswer
    }, {
        path: '/dietitian',
        name: 'dietitian',
        component: dietitian
    }, {
        path: '/portrait-data',
        name: 'portraitData',
        component: portraitData
    }, {
        path: '/portrait-data-search',
        name: 'portraitDataSearch',
        component: portraitDataSearch
    },{
        path: '/platform-data-query',
        name: 'platformDataQuery',
        component: platformDataQuery
    },
];